import React from 'react'
import ActionButton, { ActionButtonProps } from '.'
import classNames from 'classnames'
import './styles/cancelButton.scss'

export const CancelButton = ({
    children,
    className,
    ...props
}: ActionButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) => (
    <ActionButton className={classNames('cancel-button', className)} {...props}>
        {children ?? 'Cancel'}
    </ActionButton>
)
